export default __webpack_public_path__ + "static/media/completed-order-1.7d3df96a.gif";